(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer a[href*="#"]');
    if (!link) return;
    const destination = new URL(link.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
    const target = document.getElementById(destination.hash.slice(1));
    if (!target) return;
    const drawer = link.closest('header-drawer');
    const summary = drawer.querySelector('summary');
    if (typeof drawer.closeMenuDrawer === 'function') {
      event.preventDefault();
      event.stopPropagation();
      target.setAttribute('tabindex', '-1');
      drawer.closeMenuDrawer(event, target);
      summary.setAttribute('aria-expanded', 'false');
      history.pushState(null, '', destination.hash);
      target.scrollIntoView();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
